module.exports = __webpack_public_path__ + "10c5ce6d7b1e2ced341ad18422421cf7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/necklace-pearls-s.png
// module id = 1941
// module chunks = 0